import * as React from 'react';
import { compose } from 'redux';

import Fade from '@material-ui/core/Fade';
import { isBoolean, isNumber } from 'lodash';
import { withStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './_styles';
import { loaderDelay } from '../../utils/config';

const enhance = compose(withStyles(styles));

export default enhance(
  ({ classes, loading }) =>
    isNumber(loading) || (isBoolean(loading) && loading) ? (
      <Fade
        in={isNumber(loading) || isBoolean(loading) ? true : false}
        style={{
          transitionDelay: isBoolean(loading)
            ? `${loaderDelay}ms`
            : isNumber(loading)
              ? `${loading}ms`
              : '0ms',
        }}
      >
        <div className={classes.loader} style={{ position: 'fixed' }}>
          <CircularProgress size={100} />
        </div>
      </Fade>
    ) : null,
);



// WEBPACK FOOTER //
// ./src/components/loader/index.js